import { getContrastTextColor } from '../../helpers';
export { getContrastTextColor };

export const formatFullName = (firstName: string, lastName: string): string => {
  return `${firstName} ${lastName}`.trim();
};

export const formatYearMonth = (date: string | null | undefined): string => {
  if (!date || date === 'null' || date === 'CURRENT') return '';
  const [year, month] = date.split('-');
  if (!year || !month) return date;
  return `${month}/${year}`;
};

/** Escape special regex characters in a string. */
const escapeRegExp = (s: string): string => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

/** Strip the license prefix from a types string, using the translated label. */
export const stripLicensePrefix = (types: string, licenseLabel: string): string =>
  types.replace(new RegExp(`^${escapeRegExp(licenseLabel)}\\s*`, 'i'), '');

export const formatDateRange = (
  startDate: string | null | undefined,
  endDate: string | null | undefined,
  t: (key: string) => string,
): string => {
  const start = formatYearMonth(startDate);
  const end = formatYearMonth(endDate);
  if (!start && !end) return '';
  if (start && end) return `${start} - ${end}`;
  if (start) return `${start} - ${t('CV.present')}`;
  return end;
};

export const shouldShowSection = <T>(items: T[] | undefined | null): boolean => {
  return Array.isArray(items) && items.length > 0;
};

export const formatDriverLicense = (
  hasLicense: boolean,
  types: string | null,
  t: (key: string) => string,
): string | null => {
  if (!hasLicense) return null;
  const licenseKey = t('CV.drivingLicense');
  if (!types) return licenseKey;
  const cleanTypes = stripLicensePrefix(types.trim(), licenseKey);
  return cleanTypes ? `${licenseKey} ${cleanTypes}` : licenseKey;
};

export const formatMobility = (
  isMobile: boolean,
  range: string | null,
  t: (key: string, params?: Record<string, string>) => string,
): string | null => {
  if (!isMobile) return null;
  if (range) return t('CV.mobilityRange', { range });
  return t('CV.mobilityNational');
};

export const formatOpenToTraining = (
  openToTraining: boolean | null,
  t: (key: string) => string,
): string | null => {
  if (!openToTraining) return null;
  return t('Forms.PersonalInfo.openToTraining');
};

export const parseMissions = (missions: string | null | undefined): string[] => {
  if (!missions) return [];
  return missions
    .split('\n')
    .map(line => line.trim().replace(/^[-–•*]\s*/, ''))
    .filter(line => line.length > 0);
};
